import { Reducer } from "redux";

import APIClient from "web_modules/APIClient";

import {
  LOAD_EVENTS_PENDING,
  LOAD_EVENTS_FAILURE,
  LOAD_EVENTS_SUCCESS,
  ADD_EVENT_PENDING,
  ADD_EVENT_FAILURE,
  ADD_EVENT_SUCCESS,
  EventActionTypes,
  SlackEventShape,
  TRUSEventShape,
  AddEventShape,
} from "./types";

export interface EventsState {
  slackEvents: SlackEventShape[];
  TRUSEvents: TRUSEventShape[];
  loading: boolean;
  error: string;
}

const initialState: EventsState = {
  slackEvents: null,
  TRUSEvents: null,
  loading: false,
  error: null,
};

const reducer: Reducer<EventsState> = (state: EventsState = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    case LOAD_EVENTS_PENDING:
    case ADD_EVENT_PENDING:
      return {
        ...state,
        loading: true,
      };
    case LOAD_EVENTS_FAILURE:
    case ADD_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error,
      };
    case LOAD_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        slackEvents: payload.slackEvents,
        TRUSEvents: payload.TRUSEvents,
      };
    case ADD_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        TRUSEvents: [payload.TRUSEvent, ...state.TRUSEvents],
      };
    default:
      return state;
  }
};

// Action Creators
const loadEventsPending = (): EventActionTypes => ({
  type: LOAD_EVENTS_PENDING,
});

const loadEventsSuccess = ({ slack_events, events }): EventActionTypes => ({
  type: LOAD_EVENTS_SUCCESS,
  payload: {
    slackEvents: slack_events,
    TRUSEvents: events,
  },
});

const loadEventsFailure = (error: string): EventActionTypes => ({
  type: LOAD_EVENTS_FAILURE,
  error,
});

const addEventPending = (): EventActionTypes => ({
  type: ADD_EVENT_PENDING,
});

const addEventSuccess = (event: TRUSEventShape): EventActionTypes => ({
  type: ADD_EVENT_SUCCESS,
  payload: {
    TRUSEvent: event,
  },
});

const addEventFailure = (error: string): EventActionTypes => ({
  type: ADD_EVENT_FAILURE,
  error,
});

const loadEvents = (appId: number) => (dispatch: any) => {
  // set loading status
  dispatch(loadEventsPending());

  return APIClient.get(`/uw/${appId}/events`)
    .then((resp: { slack_events: SlackEventShape[]; events: TRUSEventShape[] }) => {
      dispatch(loadEventsSuccess(resp));
    })
    .catch(err => {
      dispatch(loadEventsFailure(err.message));
    });
};

const addEvent = (payload: AddEventShape) => (dispatch: any) => {
  const { appId, kind, fields } = payload;

  // set loading status
  dispatch(addEventPending());

  return APIClient.post(`/uw/${appId}/events`, {
    kind,
    fields,
  })
    .then(({ event }) => {
      dispatch(addEventSuccess(event));
    })
    .catch(err => {
      dispatch(addEventFailure(err.message));
    });
};

export { reducer as default, loadEvents, addEvent };
